var React = require('react');

function Business (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.819 26.27c5.29 0 9.58-4.242 9.58-9.476 0-5.234-4.29-9.477-9.58-9.477-5.291 0-9.58 4.243-9.58 9.477s4.289 9.476 9.58 9.476z","fill":"#FFD600","key":0}),React.createElement("path",{"d":"M46 2H3v33h43V2zM.5 2h48M18 35l-7 7M30 35l7 7M24 35v7M.565 47.678H50","stroke":"#2D2D2D","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M18.5 27a8.5 8.5 0 100-17 8.5 8.5 0 000 17zM31 13h10M31 18h10","stroke":"#2D2D2D","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M19 10v9h8","stroke":"#2D2D2D","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Business.defaultProps = {"fill":"none","viewBox":"0 0 51 50"};

module.exports = Business;

Business.default = Business;
